<template>
  <div id="js-loader" class="loader">
    <div class="loader-animation"></div>
  </div>
  <div class="maincontent" id="content" style="min-height: 605px">
    <div
      class="maincontentinner"
      style="opacity: 1; left: 0px; transition: all 0.5s ease 0s"
    >
      <div class="mt_wrap">
        <h1 class="ttl_1">{{ conts.title }} <span></span></h1>
        <nav class="breadcrumb_wrap">
          <ul class="breadcrumb">
            <li>
              <a @click="navigate('/admin/news')" style="cursor: pointer">
                {{ conts.breadcrumb.dashboard }}
              </a>
            </li>
            <li>
              <a @click="navigate('/admin/user')" style="cursor: pointer">
                {{ conts.breadcrumb.facility_staff }}</a
              >
            </li>
            <li>
              <span> {{ conts.breadcrumb.new_post }}</span>
            </li>
          </ul>
        </nav>
      </div>

      <div class="action_wrap m_b5" v-if="commonValidationError">
        <p class="s_err">
          {{ conts.error_message.common_error }}
          <span><i class="fas fa-times msg_remove"></i></span>
        </p>
      </div>

      <Spinner v-if="spinner" />

      <div
        class="modal"
        id="discardModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div class="modal_inner confirm">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form_outwrap">
                  <div class="modal_header">
                    <p class="ttl_header">{{ conts.discard.title }}</p>
                  </div>
                  <div class="modal_wrap">
                    <div class="for_wrap h_80">
                      <div class="modal_contents">
                        <p>
                          <span>{{ conts.discard.content }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="modal_footer">
                    <div class="flex_wrap f_c">
                      <div class="btn_norm reverse" id="cancel_bk">
                        <button
                          name=""
                          :value="conts.button.cancel"
                          :title="conts.button.cancel"
                          class="close"
                          dusk="delete_data"
                          @click="closeDiscard()"
                        >
                          {{ conts.button.cancel }}
                        </button>
                      </div>
                      <div class="btn_norm delete">
                        <button
                          @click="discardModal()"
                          class="btn btn-primary cln_form_btn"
                          :value="conts.button.execution"
                          :title="conts.button.execution"
                          dusk="save"
                        >
                          {{ conts.button.execution }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p
            id="close_btn"
            class="pop-remove_btn ttoltip tip-top close"
            @click="closeDiscard()"
          >
            <i class="fas fa-times"></i>
          </p>
        </div>
        <!--modal_inner-->
      </div>

      <Form
        enctype="multipart/form-data"
        autocomplete="off"
        @submit="onSubmit"
        :validation-schema="schema"
        v-slot="{ errors }"
        class="createForm"
      >
        <!--command_wrap-->
        <div class="command_wrap command_bottom">
          <div class="leftarea btn_wrap">
            <div class="return_link">
              <a id="backToList" dusk="to_list_screen"
                ><span class="icon"><i class="fas fa-chevron-left"></i></span
                >{{ conts.staff_list }}</a
              >
            </div>
            <div></div>
          </div>
          <!--leftarea-->
          <div class="rightarea">
            <div>
              <div class="btn_norm">
                <button type="submit" dusk="com_save_button">保存</button>
              </div>
            </div>
            <div class="commandtext_wrap">
              <div class="commandtextlist"></div>
            </div>
            <!--commandtext_wrap-->
          </div>
          <!--rightarea-->
        </div>
        <div class="contentout_wrap">
          <div class="content_wrap twocolumn">
            <div class="box_wrap left">
              <h2 class="ttl_2">{{ conts.title }}</h2>
              <div class="scr_outwrap">
                <div class="scr_wrap">
                  <table class="formtable">
                    <tbody>
                      <tr>
                        <th class="wid_20per">
                          {{ conts.grid.name }}
                          <span class="required">{{ conts.grid.required }}</span>
                        </th>
                        <td>
                          <div class="form_outwrap">
                            <div class="wrap wid_50per">
                              <p class="ttl_3">{{ conts.grid.last_name }}</p>
                              <div class="in_wrap">
                                <Field
                                  name="last_name"
                                  type="text"
                                  class=""
                                  :placeholder="conts.place_holder.last_name"
                                  :class="{ 'is-invalid': errors.last_name }"
                                  v-model="createUser.last_name"
                                  id="last_name"
                                />
                                <div class="msg_wrap">
                                  <span class="each_msg">
                                    {{ errors.last_name }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="wrap wid_50per">
                              <p class="ttl_3">{{ conts.grid.first_name }}</p>
                              <div class="in_wrap">
                                <div class="in_wrap">
                                  <Field
                                    name="first_name"
                                    type="text"
                                    class=""
                                    :placeholder="conts.place_holder.first_name"
                                    :class="{ 'is-invalid': errors.first_name }"
                                    v-model="createUser.first_name"
                                    id="first_name"
                                  />
                                  <div class="msg_wrap">
                                    <span class="each_msg">
                                      {{ errors.first_name }}
                                      <span class="trg"></span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="wrap wid_50per">
                              <p class="ttl_3">
                                {{ conts.grid.last_name_katakana }}
                              </p>
                              <div class="in_wrap">
                                <Field
                                  name="last_name_kana"
                                  type="text"
                                  class=""
                                  :placeholder="conts.place_holder.last_name_kana"
                                  :class="{
                                    'is-invalid': errors.last_name_kana,
                                  }"
                                  v-model="createUser.last_name_kana"
                                  id="last_name_kana"
                                />
                                <div class="msg_wrap" v-if="!existsError.last_name_kana">
                                  <span class="each_msg">
                                    {{ errors.last_name_kana }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                                <div class="msg_wrap" v-if="existsError.last_name_kana">
                                  <span class="each_msg">
                                    {{ conts.error_message.last_name_kana_error }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="wrap wid_50per">
                              <p class="ttl_3">
                                {{ conts.grid.first_name_katakana }}
                              </p>
                              <div class="in_wrap">
                                <Field
                                  name="first_name_kana"
                                  type="text"
                                  class=""
                                  :placeholder="conts.place_holder.first_name_kana"
                                  :class="{
                                    'is-invalid': errors.first_name_kana,
                                  }"
                                  v-model="createUser.first_name_kana"
                                  id="first_name_kana"
                                />
                                <div class="msg_wrap" v-if="!existsError.first_name_kana">
                                  <span class="each_msg">
                                    {{ errors.first_name_kana }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                                <div class="msg_wrap" v-if="existsError.first_name_kana">
                                  <span class="each_msg">
                                    {{ conts.error_message.first_name_kana_error }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="form_outwrap" style="display: none">
                              <div class="wrap wid_100per">
                                <p class="ttl_3">
                                  {{ conts.grid.alphabet }}
                                  <small class="input_description m_l10">{{
                                    conts.grid.alphabet_dec
                                  }}</small>
                                </p>
                                <div class="in_wrap">
                                  <Field
                                    name="alphabet_name"
                                    type="text"
                                    class=""
                                    :class="{
                                      'is-invalid': errors.alphabet_name,
                                    }"
                                    v-model="createUser.alphabet_name"
                                    id="alphabet_name"
                                  />
                                  <div class="msg_wrap">
                                    <span class="each_msg">
                                      {{ errors.alphabet_name }}
                                      <span class="trg"></span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th class="wid_20per">
                          {{ conts.grid.user_code
                          }}<span class="required">{{ conts.grid.required }}</span>
                        </th>
                        <td>
                          <div class="form_outwrap">
                            <div class="wrap wid_100per">
                              <div class="in_wrap">
                                <p class="ttl_3">
                                  <small class="input_description">{{
                                    conts.grid.user_code_dec
                                  }}</small>
                                </p>
                                <Field
                                  autcomplete="nope"
                                  name="user_code"
                                  type="text"
                                  :class="{
                                    'is-invalid': errors.user_code,
                                  }"
                                  v-model="createUser.user_code"
                                  :placeholder="conts.place_holder.user_code"
                                  id="userCode"
                                  ref="userCode"
                                />

                                <div class="msg_wrap" v-if="!existsError.user_code">
                                  <span class="each_msg">
                                    {{ errors.user_code }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                                <div class="msg_wrap" v-if="existsError.user_code">
                                  <span class="each_msg">
                                    {{ conts.error_message.user_code_exists }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th class="wid_20per">
                          {{ conts.grid.contact_address
                          }}<span class="required">{{ conts.grid.required }}</span>
                        </th>
                        <td>
                          <div class="form_outwrap">
                            <div class="wrap wid_100per">
                              <p class="ttl_3">{{ conts.grid.mail_address }}</p>
                              <div class="in_wrap">
                                <Field
                                  name="email"
                                  type="email"
                                  class=""
                                  :class="{
                                    'is-invalid': errors.email,
                                  }"
                                  v-model="createUser.email"
                                  :placeholder="conts.place_holder.email"
                                  id="email"
                                />
                                <div class="msg_wrap" v-if="!existsError.email">
                                  <span class="each_msg">
                                    {{ errors.email }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                                <div class="msg_wrap" v-if="existsError.email">
                                  <span class="each_msg">
                                    {{ conts.error_message.email_exists }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form_outwrap">
                            <div class="wrap wid_100per">
                              <p class="ttl_3">
                                {{ conts.grid.tel
                                }}<small class="not_required">{{
                                  conts.grid.phone
                                }}</small>
                              </p>
                              <div class="in_wrap">
                                <Field
                                  id="phone"
                                  type="text"
                                  name="phone"
                                  class="alpha_num_sym"
                                  :class="{
                                    'is-invalid': errors.phone,
                                  }"
                                  v-model="createUser.phone"
                                  :placeholder="conts.place_holder.phone"
                                />

                                <div class="msg_wrap">
                                  <span class="each_msg">
                                    {{ errors.phone }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th class="wid_20per">
                          {{ conts.grid.password }}
                          <span class="required">{{ conts.grid.required }}</span>
                        </th>
                        <td>
                          <div class="form_outwrap">
                            <div class="wrap wid_100per">
                              <div class="in_wrap">
                                <p class="ttl_3">
                                  <small class="input_description">{{
                                    conts.grid.password_dec
                                  }}</small>
                                </p>
                                <Field
                                  autcomplete="nope"
                                  name="password"
                                  type="password"
                                  class="alpha_num_sym"
                                  v-model="createUser.password"
                                  :class="{
                                    'is-invalid': errors.password,
                                  }"
                                  id="password"
                                  :placeholder="conts.place_holder.password"
                                />
                                <div class="msg_wrap">
                                  <span class="each_msg">
                                    {{ errors.password }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form_outwrap">
                            <div class="wrap wid_100per">
                              <div class="in_wrap">
                                <p class="ttl_3">
                                  <small class="input_description">{{
                                    conts.grid.password_dec
                                  }}</small>
                                </p>
                                <Field
                                  name="password_confirmation"
                                  type="password"
                                  class="alpha_num_sym"
                                  v-model="createUser.password_confirmation"
                                  :class="{
                                    'is-invalid': errors.password_confirmation,
                                  }"
                                  id="password"
                                  ref="password"
                                  :placeholder="conts.place_holder.password_confirmation"
                                />
                                <div class="msg_wrap">
                                  <span class="each_msg">
                                    {{ errors.password_confirmation }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th class="wid_20per">
                          {{ conts.grid.section }}
                        </th>
                        <td>
                          <div class="form_outwrap" v-if="!hideSection">
                            <div class="wrap wid_100per p_r0">
                              <div>
                                <p class="ttl_3">
                                  {{ conts.grid.section }}
                                </p>
                              </div>
                              <div class="in_wrap">
                                <div class="select_wrap">
                                  <Field
                                    required=""
                                    name="section"
                                    as="select"
                                    class="form-control"
                                    v-model="createUser.section"
                                    @change="onChange"
                                  >
                                    <option value="" disabled>
                                      {{ conts.place_holder.section }}
                                    </option>
                                    <option
                                      v-for="section in sections"
                                      :key="section.id"
                                      :value="section.id"
                                    >
                                      {{ section.title }}
                                    </option>
                                  </Field>
                                </div>
                                <div class="msg_wrap">
                                  <span class="each_msg">
                                    {{ errors.section }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form_outwrap">
                            <div class="wrap wid_100per p_r0">
                              <div>
                                <p class="ttl_3">
                                  {{ conts.grid.group }}
                                </p>
                              </div>
                              <div class="in_wrap">
                                <div class="select_wrap">
                                  <Field
                                    required=""
                                    name="group"
                                    as="select"
                                    class="form-control"
                                    @change="changeDepartment($event)"
                                    v-model="createUser.group"
                                  >
                                    <option value="">
                                      {{ conts.place_holder.section }}
                                    </option>

                                    <option
                                      v-for="group in seletcedGroup"
                                      :key="group.id"
                                      :value="group.id"
                                    >
                                      {{ group.name }}
                                    </option>
                                  </Field>
                                </div>
                                <div class="msg_wrap">
                                  <span class="each_msg">
                                    {{ errors.group }}
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th class="wid_20per">
                          {{ conts.grid.position }}
                        </th>
                        <td>
                          <div class="form_outwrap">
                            <div class="wrap wid_100per">
                              <div class="in_wrap">
                                <p class="ttl_3">
                                  <small class="input_description">{{
                                    conts.grid.position
                                  }}</small>
                                </p>
                                <div class="select_wrap">
                                  <Field
                                    required=""
                                    name="role"
                                    as="select"
                                    class="form-control"
                                    v-model="createUser.role"
                                    @change="setRoleRank($event)"
                                  >
                                    <option value="" data-rank="">
                                      {{ conts.place_holder.position }}
                                    </option>

                                    <option value="取締役会長" data-rank="1000">取締役会長</option>
                                    <option value="代表取締役社長" data-rank="900">
                                      代表取締役社長
                                    </option>
                                    <option value="取締役副社長" data-rank="800">取締役副社長</option>
                                    <option value="専務取締役" data-rank="700">
                                      専務取締役
                                    </option>
                                    <option value="取締役" data-rank="600">取締役</option>

                                    <option value="部長執行役員" data-rank="500">
                                      部長執行役員
                                    </option>
                                    <option value="部長" data-rank="400">部長</option>
                                    <option value="課長" data-rank="300">課長</option>
                                    <option value="係長" data-rank="200">係長</option>
                                    <option value="主任" data-rank="100">主任</option>

                                    <!-- <option value="代表取締役社長">代表取締役社長</option>
                                    <option value="副社長">副社長</option>
                                    <option value="専務取締役">専務取締役</option>
                                    <option value="取締役">取締役</option>
                                    <option value="部長執行役員">部長執行役員</option>
                                    <option value="部長">部長</option>
                                    <option value="課長">課長</option>
                                    <option value="係長">係長</option>
                                    <option value="主任">主任</option>
                                    <option value="一般社員">一般社員</option>
                                    <option value="準社員">準社員</option>
                                    <option value="嘱託">嘱託</option>
                                    <option value="パート">パート</option> -->
                                  </Field>
                                </div>
                                <div class="msg_wrap" v-if="departmentValidation">
                                  <span class="each_msg">
                                    役職を選択する前に部門を選択してください。
                                    <span class="trg"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!--formtable-->
                </div>
                <!--scr_wrap-->
              </div>
              <!--scr_outwrap-->
            </div>
            <!--box_wrap-->

            <!--box_wrap-->
            <div class="box_wrap right">
              <!-- <h2 class="ttl_2">公開情報</h2> -->
              <div class="form_outwrap">
                <div class="wrap wid_100per p_r0">
                  <div><p class="ttl_3">アイキャッチ</p></div>
                  <div class="in_wrap">
                    <div class="filegroup m_b20">
                      <input
                        type="file"
                        id="ec_pls"
                        name="eyecatch"
                        value=""
                        class="ec_catch"
                        accept=".jpg"
                      />
                      <label for="ec_pls" class="filelabel">ファイルを選択</label>
                      <input type="hidden" name="ec_pastdel" value="del" />
                    </div>
                  </div>
                  <div id="prev"></div>
                </div>
                <div class="wrap wid_100per p_r0">
                  <div>
                    <p class="ttl_3">
                      {{ conts.grid.authority }}
                    </p>
                  </div>
                  <div class="in_wrap">
                    <div class="form_outwrap">
                      <div class="wrap">
                        <div class="in_wrap">
                          <label>
                            <Field
                              type="radio"
                              name="is_admin"
                              :value="true"
                              v-model="createUser.is_admin"
                              class="radiobox"
                            /><span :dusk="conts.grid.is_admin"></span
                            ><span class="radiotxt">{{ conts.grid.is_admin }}</span>
                          </label>
                        </div>
                      </div>
                      <div class="wrap">
                        <div class="in_wrap">
                          <label>
                            <Field
                              type="radio"
                              name="is_admin"
                              :value="false"
                              v-model="createUser.is_admin"
                              class="radiobox"
                            /><span :dusk="conts.grid.is_user"></span
                            ><span class="radiotxt">{{ conts.grid.is_user }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="msg_wrap">
                      <span class="each_msg">
                        {{ errors.is_admin }}
                        <span class="trg"></span>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="wrap wid_100per p_r0">
                  <div>
                    <p class="ttl_3">
                      {{ conts.grid.sex
                      }}<span class="required">{{ conts.grid.required }}</span>
                    </p>
                  </div>
                  <div class="in_wrap">
                    <div class="form_outwrap">
                      <div class="wrap">
                        <div class="in_wrap">
                          <label>
                            <Field
                              type="radio"
                              name="sex"
                              :value="conts.grid.male"
                              v-model="createUser.sex"
                              class="radiobox"
                            /><span :dusk="conts.grid.male"></span
                            ><span class="radiotxt">{{ conts.grid.male }}</span>
                          </label>
                        </div>
                      </div>
                      <div class="wrap">
                        <div class="in_wrap">
                          <label>
                            <Field
                              type="radio"
                              name="sex"
                              :value="conts.grid.female"
                              v-model="createUser.sex"
                              class="radiobox"
                            />
                            <span :dusk="conts.grid.female"></span
                            ><span class="radiotxt">{{ conts.grid.female }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="msg_wrap">
                      <span class="each_msg">
                        {{ errors.sex }}
                        <span class="trg"></span>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="wrap p_r0">
                  <p class="ttl_3">
                    {{ conts.grid.hire_date
                    }}<span class="required">{{ conts.grid.required }}</span>
                  </p>

                  <div class="in_wrap time_wrap">
                    <div class="ttl_3">
                      <Field
                        type="date"
                        name="here_date"
                        :placeholder="conts.place_holder.hire_date"
                        class="here-date"
                        autocomplete="off"
                      />

                      <span style="display: none">@</span>
                      <input
                        style="display: none"
                        name="public_hour"
                        type="text"
                        placeholder="00"
                        class="hour"
                      />
                      <span style="display: none">:</span>
                      <input
                        style="display: none"
                        name="public_sec"
                        type="text"
                        placeholder="00"
                        class="minutes"
                      />
                    </div>

                    <div class="msg_wrap" v-if="!hireDateFormat">
                      <span class="each_msg">
                        {{ errors.here_date }}
                        <span class="trg"></span>
                      </span>
                    </div>
                    <div class="msg_wrap" v-if="hireDateFormat">
                      <span class="each_msg">
                        {{ conts.error_message.date_format }}
                        <span class="trg"></span>
                      </span>
                    </div>
                    <!--datepickbox-->
                  </div>
                  <!--in_wrap-->
                </div>
                <!--wrap-->
              </div>
              <!--form_outwrap-->
            </div>
            <!--box_wrap-->
          </div>
          <!--content_wrap-->
        </div>
        <!--contentoutwrap-->
      </Form>
    </div>
    <!--maincontentinner-->
  </div>
</template>

<script>
/* eslint-disable */
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";
import Spinner from "../../../components/control_panel/Spinner.vue";
import CONST from "../../../const/control_panel/user";

import $ from "jquery";

export default {
  name: "User Create",
  setup() {
    let schema = Yup.object().shape(
      {
        first_name: Yup.string().required(CONST.CREATE.error_message.first_name),
        last_name: Yup.string().required(CONST.CREATE.error_message.last_name),
        last_name_kana: Yup.string().required(CONST.CREATE.error_message.last_name_kana),
        first_name_kana: Yup.string().required(
          CONST.CREATE.error_message.first_name_kana
        ),
        user_code: Yup.string().required(CONST.CREATE.error_message.user_code),
        email: Yup.string()
          .required(CONST.CREATE.error_message.email)
          .email(CONST.CREATE.error_message.email_format),
        password: Yup.string().required(CONST.CREATE.error_message.password),
        password_confirmation: Yup.string()
          .required(CONST.CREATE.error_message.password_confirmation)
          .oneOf(
            [Yup.ref("password")],
            "確認パスワードはパスワードと同じを指定してください。"
          ),
        sex: Yup.string().required(CONST.CREATE.error_message.sex),
        here_date: Yup.string().required(CONST.CREATE.error_message.hire_date),
        is_admin: Yup.string().required(CONST.CREATE.error_message.is_admin),
        phone: Yup.string()
          .nullable()
          .notRequired()
          .when("phone", {
            is: (value) => value?.length,
            then: (rule) =>
              rule.matches(
                /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
                CONST.CREATE.error_message.phone_format
              ),
          }),
      },
      [
        // Add Cyclic deps here because when require itself
        ["phone", "phone"],
      ]
    );
    return {
      schema,
    };
  },
  data() {
    return {
      conts: CONST.CREATE,
      createUser: {
        first_name: "",
        last_name: "",
        first_name_kana: "",
        last_name_kana: "",
        user_code: "",
        email: "",
        phone: "",
        password: "",
        here_date: "",
        section: "",
        group: "",
        rank: null,
      },
      commonValidationError: false,
      formInputChange: false,
      date: "",
      hours: "00",
      minutes: "00",
      hoursValidated: true,
      minutesValidated: true,
      dateValidated: true,
      existsError: {},
      sections: [],
      group: [],
      seletcedGroup: [],
      seletcedRole: [],
      hideSection: true,
      userImageUpload: new FormData(),
      hireDateFormat: false,
      departmnet: [],
      departmentValidation: false,
      isDepartmentSelected: false,
    };
  },
  computed: {
    ...mapState("user", ["validationError", "groups", "role"]),
    ...mapState("common", ["spinner"]),
  },

  components: {
    Form,
    Field,
    Spinner,
  },
  created() {
    this.getGroups();
    this.getRole();
  },
  watch: {
    validationError(error) {
      this.existsError = error;
    },
    groups(groups) {
      this.seletcedGroup = groups;
    },
    role(role) {
      this.seletcedRole = role;
    },
  },
  methods: {
    ...mapActions("user", ["userRegister", "getGroups", "getRole"]),

    onSubmit() {
      if (!this.hireDateFormat && !this.departmentValidation) {
        if (this.date != "") {
          this.createUser.published_at = this.date;
        }
        this.userRegister({
          user: this.createUser,
          file: this.userImageUpload,
        });
      }
    },

    setRoleRank(e) {
      this.createUser.rank =
        e.target.options[e.target.options.selectedIndex].dataset.rank;

      if (e.target.value == null || e.target.value == "") {
        this.departmentValidation = false;
      } else {
        if (this.createUser.group != "" && this.createUser.group != null) {
          this.departmentValidation = false;
        } else {
          this.departmentValidation = true;
        }
      }
    },
    changeDepartment(e) {
      if (e.target.value == null || e.target.value == "") {
        if (this.createUser.rank != null) {
          this.departmentValidation = true;
        } else {
          this.departmentValidation = false;
        }
      } else {
        this.departmentValidation = false;
      }
    },

    /**
     * discurd the changes
     * @author Elavarasan
     *  @date 23/10/2021
     */
    discardModal() {
      this.$router.push({ path: "/admin/news" });
    },
    /**
     * close discurd confirm popup
     * @author Elavarasan
     *  @date 23/10/2021
     */
    closeDiscard() {
      $("#discardModal").removeClass("open");
    },
    /**
     * Navigate bredcubms routes
     * @author Elavarasan
     *  @date 23/10/2021
     */
    navigate(url) {
      if (this.formInputEvent == true) {
        $("#discardModal").addClass("open");
      } else {
        this.$router.push({ path: url });
      }
    },
    validateDate(dateString) {
      return moment(dateString, "YYYY-MM-DD", true).isValid();
    },

    onChange: function (event) {
      this.seletcedGroup = [];
      this.group.forEach((element) => {
        if (element.key == event.target.value) {
          this.seletcedGroup = element.value;

          if (
            element.key == 1 ||
            element.key == 2 ||
            element.key == 8 ||
            element.key == 9
          ) {
            this.createUser.group = element.value[0];
            this.hideSection = false;
          } else {
            this.hideSection = true;
          }
          return true;
        }
      });
    },
  },
  mounted() {
    setTimeout(() => {
      document.getElementById("userCode").value = "";
      document.getElementById("password").value = "";
      this.$refs.userCode.value = "";
      this.$refs.password.value = "";
    }, 2000);

    let vueThis = this;
    /**
     * form input changes find
     * @author Elavarasan
     *  @date 23/10/2021
     */
    $("form").change(function () {
      vueThis.formInputChange = true;
    });

    $(document).on("change", ".ec_catch", function (e) {
      var file = $(this).prop("files")[0];
      if (file) {
        vueThis.userImageUpload.append("key", "users");
        vueThis.userImageUpload.append(
          "display_name",
          $(this)
            .val()
            .replace(/C:\\fakepath\\/i, "")
        );
        vueThis.userImageUpload.append("uploadfile", file);
      }
    });

    /**
     * back to list naviation route
     * @author Elavarasan
     *  @date 23/10/2021
     */
    $("#backToList").click(function () {
      if (vueThis.formInputChange == true) {
        $("#discardModal").addClass("open");
      } else {
        vueThis.$router.push({ path: "/admin/user" });
      }
    });

    $(document).on("click", "button[type=submit]", function () {
      if (
        vueThis.createUser.first_name == "" ||
        vueThis.createUser.last_name == "" ||
        vueThis.createUser.last_name_kana == "" ||
        vueThis.createUser.first_name_kana == "" ||
        vueThis.createUser.email == "" ||
        vueThis.createUser.password == "" ||
        vueThis.createUser.user_code == ""
      ) {
        vueThis.commonValidationError = true;
      } else {
        vueThis.commonValidationError = false;
      }
    });

    $(function () {
      $(document).on("change", ".here-date", function () {
        let date = $(this).val().replace(/\//g, "-");

        let fromDate = Date.parse(date);

        if (isNaN(fromDate)) {
          vueThis.hireDateFormat = true;

          return false;
        }

        let dateFormat = vueThis.validateDate(date);

        if (dateFormat) {
          vueThis.createUser.here_date = date;
          vueThis.hireDateFormat = false;
        } else {
          vueThis.hireDateFormat = true;
        }
      });

      $(document).on("keyup", ".hour", function () {
        if (isNaN($(this).val()) || parseInt($(this).val()) > 23) {
          vueThis.hoursValidated = false;
          return false;
        } else {
          vueThis.hours = $(this).val();
          vueThis.hoursValidated = true;
          return true;
        }
      });
      $(document).on("keyup", ".minutes", function () {
        vueThis.minutes = $(this).val();

        if (isNaN($(this).val()) || parseInt($(this).val()) > 59) {
          vueThis.minutesValidated = false;
          return false;
        } else {
          vueThis.minutes = $(this).val();

          vueThis.minutesValidated = true;
          return true;
        }
      });
    });
  },
};
</script>

<style scoped>
/* 外部CSSスタイルシートを追加する */
@import "../../../assets/control_panel/scss/main.scss";
@import "~@/assets/front_component/js/timepicker/datepicker.css";
</style>
